import styles from "./styles.module.css"

export default function InputDouble({ children }) {
    return (
        <div className={styles.inputDouble}>
            {children}
        </div>
    );
}